import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { STATUS } from "@/lib/medicoes";
import { MedicoesList } from "@/pages/FornecedorContratoDetalhe";

export default function FornecedorMedicoes() {
  const [sp, setSp] = useSearchParams();
  const status = sp.get("status") || "";
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/fornecedor/medicoes", { params: status ? { status } : {} }).then((r) => setItems(r.data.items));
  }, [status]);
  return (
    <div className="space-y-6" data-testid="fornecedor-medicoes">
      <div>
        <div className="uppercase-label">Área do Fornecedor</div>
        <h1 className="font-heading text-4xl tracking-tight mt-2">Minhas medições</h1>
        <p className="text-sm text-[#94A3B8] mt-2">Para criar uma nova medição, abra o contrato desejado em “Meus contratos”.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {[["", "Todas"], ...Object.entries(STATUS).map(([k, s]) => [k, s.label])].map(([k, l]) => (
          <button key={k || "all"} data-testid={`fm-filter-${k || "all"}`} onClick={() => setSp(k ? { status: k } : {})}
                  className={`px-3 py-1.5 rounded-full text-xs border ${status === k ? "border-[#FFDF00] text-[#FFDF00]" : "border-[#334155] text-[#94A3B8]"}`}>{l}</button>
        ))}
      </div>
      <div className="tce-card p-4">
        {items === null ? <p className="text-[#94A3B8]">Carregando…</p> : <MedicoesList items={items} base="/fornecedor/medicoes" />}
      </div>
    </div>
  );
}
